/* eslint-disable class-methods-use-this */
import { registerPlugin, WebPlugin } from '~capacitor-plugins/core';

import { canMockPrinting } from './canMock';
import type { BadgePrinterPlugin, Printer, CapacitorPrintOptions } from './definitions';

// eslint-disable-next-line import/prefer-default-export
export class BadgePrinterWeb extends WebPlugin implements BadgePrinterPlugin {
  findBluetoothPrinters(): Promise<{ printers: Printer[] }> {
    // If we're in a development mode, return some mock printers to simplify testing
    if (canMockPrinting) {
      const rand = Math.floor(Math.random() * 100);
      return Promise.resolve<{ printers: Printer[] }>({
        printers: [
          { brand: 'Brother', model: 'QL-820NWB', type: 'bluetooth', serialNumber: 'Mock Printer' },
          {
            brand: 'Brother',
            model: 'QL-820NWBc',
            type: 'bluetooth',
            serialNumber: `Dynamic Mock Printer #${rand}`,
          },
        ],
      });
    }

    throw new Error('Method not implemented.');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  printBadge(options: CapacitorPrintOptions): Promise<{ result: boolean }> {
    throw new Error('Method not implemented.');
  }

  openNativeBluetoothSettings(): Promise<void> {
    throw new Error('Method not implemented.');
  }
}

export const BadgePrinter = registerPlugin<BadgePrinterPlugin>('BadgePrinter', {
  web: () => new BadgePrinterWeb(),
});
